import API from "./lib/api";
import { concessionUrl } from "./lib/url";


export const getAllConcessionApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get( 
            `restaurant/${restaurant_id}${concessionUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addConcessionApi = async (concessionData) => {
    try {
        
        const response = await API.post( 
            `restaurant${concessionUrl}`,
            concessionData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const editConcessionApi = async (concessionData, id) => {
    try {
        
        const { data } = await API.put( 
            `restaurant${concessionUrl}/${id}`,
            concessionData
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const deleteConcessionApi = async (id) => {
    try {
        
        const response = await API.delete( 
            `restaurant${concessionUrl}/${id}`
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const getSingleConcessionApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `restaurant${concessionUrl}/${id}`
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}